import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';
import { cloneElement, isValidElement } from 'react';

const ButtonTertiaryMedium = ({
  title,
  preIcon,
  posIcon,
  type = 'button',
  loading = false,
  active = false,
  ...props
}) => {
  return (
    <button
      type={type}
      {...props}
      className={cn(
        'bg-trans hover:bg-primary-primaryFill disabled:cursor-not-allowed disabled:pointer-events-none outline-none border-none inline-flex justify-center items-center',
        active ? 'bg-primary-primaryFill' : '',
        'text-body-medium font-semibold text-primary-primary disabled:text-black-low',
        'h-[32px] py-[7px] px-[12px] gap-[6px] rounded-[6px] flex items-center',
        props?.className
      )}
      style={{
        ...(props?.style ?? {}),
        ...{
          paddingRight: `${preIcon ? '8px' : undefined}`,
          paddingLeft: `${posIcon ? '8px' : undefined}`,
        },
      }}
    >
      {posIcon && (
        <div
          className={
            'w-[16px] h-[18px] flex items-center justify-center disabled:text-black-low'
          }
        >
          {posIcon}
        </div>
      )}
      {isValidElement(title) ? (
        cloneElement(title, {
          className: cn(title.props.className, 'line-clamp-1'),
        })
      ) : (
        <span className="line-clamp-1">{title}</span>
      )}
      <Spin spinning={loading} size="small" />
      {preIcon && (
        <div
          className={
            'w-[16px] h-[18px] flex items-center justify-center disabled:text-black-low'
          }
        >
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonTertiaryMedium;
